import { React, useState, useEffect } from 'react';
import { Form, Button, Stack, Card, Table, Alert } from 'react-bootstrap';
import * as api from 'services/api';
import './PhoneUpdater.css';
import { useTranslation } from 'react-i18next';

export function ResidentPhoneUpdater({ equipmentData, setNewPhoneNumber, newPhoneNumber, setShowDetails, interventionType }) {
    const { t } = useTranslation();
    const [showUpdatedPhones, setShowUpdatedPhones] = useState(false);
    const [phone1, setPhone1] = useState('');
    const [phone2, setPhone2] = useState('');
    const [saveButtonEnabled, setSaveButtonEnabled] = useState(false);
    const [error, setError] = useState('');
    const [showError, setShowError] = useState(false);
    const [selectedIndex, setSelectedIndex] = useState(null);
    const [residentDevices, setResidentDevices] = useState([]);
    const [residentDevice, setResidentDevice] = useState({
        residentId: 0,
        terminalId: '',
        terminalUserRelationId: 0,
        model: '',
        phone: '',
        imei: '',
        telephone1: '',
        telephone2: ''
    });
    const [digitRegex, setDigitRegex] = useState(0);

    useEffect(() => {

        const fetchDwellingMobileDevices = async () => {

            const response = await api.getResidentMobileDevices(equipmentData.equipmentIdent);
            console.log(response);
            if (response.status === 200) {

                const devices = response.data;
                setResidentDevices(devices);
                if (devices.length === 1) {
                    handleSelectDevice(devices[0], 0);
                }

                
            } else {
                console.log('FAILED RECOVERING CONFIGS');
            }
        };

        fetchDwellingMobileDevices();
        setDigitRegex(new RegExp(`^\\d{0,${interventionType.controlDigitsNumber}}$`));

    }, [])

    const handleSave = async (event) => {

        event.preventDefault();

        setSaveButtonEnabled(false);

        const isDelete = interventionType.deletePhone === true;
        const selected = interventionType.selectedPhone;

        let phone1, phone2;

        if (isDelete) {
            // Solo actualiza el teléfono seleccionado
            phone1 = selected === 1 ? newPhoneNumber : residentDevice.telephone1;
            phone2 = selected === 2 ? newPhoneNumber : residentDevice.telephone2;
        } else {
            // Mueve los teléfonos hacia adelante
            if (selected === 1) {
                phone1 = newPhoneNumber;
                phone2 = residentDevice.telephone1;
            } else if (selected === 2) {
                phone1 = residentDevice.telephone1;
                phone2 = newPhoneNumber;
            }
        }

        setPhone1(phone1);
        setPhone2(phone2);

        const payload = {
            terminalUserRelationId: residentDevice.terminalUserRelationId,
            terminalId: residentDevice.terminalId,
            imei: residentDevice.imei,
            newPhone: newPhoneNumber,
            oldPhone: residentDevice.phone
        }

        const responseUpdateTam = await api.updateResidentTam(residentDevice.residentId, payload);
        console.log(responseUpdateTam);
        setShowUpdatedPhones(true);
        if (responseUpdateTam.status === 200) {

            const phones = {
                phone1: phone1,
                phone2: phone2
            }

            const responseUpdatePhones = await api.updateResidentPhone(residentDevice.residentId, phones);
            console.log(responseUpdatePhones);

            if (responseUpdatePhones.status === 200) {
                setShowDetails(true);
            } else {
                setError(responseUpdatePhones.data.message);
            }

        } else {
            if (responseUpdateTam.data != null && responseUpdateTam.data.message != null) {
                setError(responseUpdateTam.data.message);
            } else {
                setError(t('pUpdaterPhoneGenericError'));
            }
            setShowError(true);
            console.error('Error al actualizar los teléfonos:');
        } 

    }; 


    const handleSelectDevice = (device, index) => {
        console.log(device);
        setResidentDevice({
            residentId: device.residentId,
            terminalId: device.terminalId,
            model: device.model,
            phone: device.phone,
            imei: device.imei,
            terminalUserRelationId: device.terminalUserRelationId,
            telephone1: device.telephone1,
            telephone2: device.telephone2
        });
        setSelectedIndex(index);
    };


    useEffect(() => {
        let hasPhoneDigits = false;
        hasPhoneDigits = newPhoneNumber.trim().length > 4;
        if (interventionType.controlDigitsNumber > 0) hasPhoneDigits = newPhoneNumber.trim().length === interventionType.controlDigitsNumber;
        const hasSelectedDevice = residentDevice && residentDevice.terminalId;

        setSaveButtonEnabled(hasPhoneDigits && hasSelectedDevice);
    }, [newPhoneNumber, residentDevice]);



    return (
        <Card className="UpdatePhone mt-3 p-4">
            <Card.Title className="mb-3">{t('md.UpdateMobilePhone')}</Card.Title>

                <Stack direction="horizontal" className="justify-content-between mb-4" gap={3}>
                    {residentDevices.length > 0 ? (
                        <Table size="sm" className='mb-0 mt-2'>
                            <thead>
                                <tr style={{ fontSize: '13px' }}>
                                    <th>{t('md.ResidentName')}</th>
                                    <th>{t('md.Model')}</th>
                                    <th>{t('md.Phone')}</th>
                                    <th>{t('md.Imei')}</th>

                                </tr>
                            </thead>
                            <tbody>
                                {residentDevices.map((device, index) => (
                                    <tr
                                        key={index}
                                        style={{
                                            fontSize: '13px', fontWeight: 'normal',
                                            border: selectedIndex === index ? '2px solid #007BFF' : 'none',
                                            cursor: 'pointer'
                                        }}
                                        onClick={() => handleSelectDevice(device, index)}>
                                        <td>{device.residentName}</td>
                                        <td style={{ color: 'gray' }}>{device.model}</td>
                                        <td style={{ color: 'gray' }}>{device.phone}</td>
                                        <td style={{ color: 'gray' }}>{device.imei}</td>
                                    </tr>
                                ))}
                            </tbody>
                        </Table>
                    ) : (<p>{t('eListNoData')}</p>)}
                </Stack>

                <Form>
                    <Stack direction="horizontal" className="justify-content-between" gap={3}>
                        <div className="flex-grow-1" style={{ maxWidth: '349px' }}>
                            <Form.Group>
                                <Form.Control
                                    className="bg-light UpdatePhone__input"
                                    type="number"
                                    placeholder={t('pUpdaterNewPhone')}
                                    value={newPhoneNumber}
                                    onChange={(e) => {
                                        const value = e.target.value;
                                        if (interventionType.controlDigitsNumber > 0) {
                                            if (digitRegex.test(value)) {
                                                setNewPhoneNumber(value);
                                            }
                                        } else {
                                            setNewPhoneNumber(value);
                                        }
                                    }}
                                />
                            </Form.Group>
                        </div>
                        <Button
                            type="submit"
                            variant={showUpdatedPhones ? 'outline-dark' : 'dark'}
                            onClick={handleSave}
                            disabled={!saveButtonEnabled}
                        >
                            {t('ccSave')}
                        </Button>
                    </Stack >

                    {showUpdatedPhones && (
                        <Stack direction="horizontal" gap={2} className="mt-3 flex-wrap flex-sm-nowrap">
                        <small className='flex-grow-1 w-100'>
                            <div className="d-inline d-sm-block">{t('pUpdaterPhone')} 1:</div> <b>{phone1}</b></small>
                            <small className='flex-grow-1 w-100'>
                            <div className="d-inline d-sm-block">{t('pUpdaterPhone')} 2:</div> <b>{phone2}</b></small>
                        </Stack >
                    )}

                    {showError && (
                        <Alert className="EquipmentDetails mt-3 p-4" variant="error">
                            {error}
                        </Alert>
                    )}
            </Form>
        </Card>
    );
}
